/**
 * Canonical "fecha de registro" for a warehouse piece: REG completion time when present,
 * else legacy fallback to piece createdAt.
 */
export function registrationIsoFromWarehouseListItem(item: {
  createdAt?: string;
  inventoryRecordItem?: { record?: { completedAt?: string | null } };
}): string | undefined {
  const completed = item.inventoryRecordItem?.record?.completedAt;
  if (completed) return completed;
  return item.createdAt;
}
